export const getMetadataTagDisplayName = (displayName: string, id: string) =>
  `${displayName} (${id})`
